import { useNotify } from '@globaleris/ui.library'
import { Button, Paper } from '@material-ui/core'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { EnumCommodity } from '../../../api'
import { EnumEstadoLead } from '../../../api/oData/enums/enumEstadoLead'
import { EnumTipoLead } from '../../../api/oData/enums/enumTipoLead'
import Page from '../../../components/page/page'
import PageCenterColumn from '../../../components/page/pageCenterColumn'
import PageHeader from '../../../components/page/pageHeader'
import { AnnexedParamSectionTableModel } from '../../../components/shared/annexedParamAccordionSection/annexedParamAccordionSection.model'
import { NonAuthRoutes } from '../../../model'
import { LeadForm, LeadFormModel } from '../components/leadForm/leadForm'
import { mapAddLeadFormToPostRequest } from '../leads.mapper'
import { checkLeadCodeExists, saveLead } from '../leads.service'

interface LeadsAddPageProps {
  location?: {
    state: {
      commodity?: EnumCommodity
      leadType?: EnumTipoLead
    }
  }
}

export const LeadsAddPage: React.FC<LeadsAddPageProps> = props => {
  const [t] = useTranslation(['globalerisLibrary', 'leads', 'enums'])
  const { info, error } = useNotify()
  const history = useHistory()
  const [leadFormData, setLeadFormData] = useState<LeadFormModel>({
    commodity: props.location?.state?.commodity,
    leadType: props.location?.state?.leadType,
    leadState: EnumEstadoLead.SinEvaluar
  } as LeadFormModel)
  const [annexedParams, setAnnexedParams] = useState<AnnexedParamSectionTableModel[]>([])
  const [formIsValid, setFormIsValid] = useState<boolean>(false)

  const commodity = props.location?.state?.commodity
  const leadType = props.location?.state?.leadType

  if (!commodity || !leadType) {
    error(t('leads:fetchErrors.props'))
    history.goBack()
    return <></>
  }

  // #region Handlers Starts

  const handleFormChange = (formState: LeadFormModel, formIsCompleted: boolean) => {
    setLeadFormData(formState)
    setFormIsValid(formIsCompleted)
  }
  const handleAnnexedParamChange = (annexedParamsDataTable: AnnexedParamSectionTableModel[]) => {
    setAnnexedParams(annexedParamsDataTable)
  }

  const handleGoBack = () => {
    history.goBack()
  }

  const handleSave = async () => {
    const duplicateCheck = await checkLeadCodeExists(leadFormData.code, commodity, leadType)
    if (!duplicateCheck.success) {
      error(t('leads:notifications.addLead.error'))
      return
    }
    if (duplicateCheck.data) {
      error(t('leads:notifications.duplicateCode.error'))
      return
    }
    const request = mapAddLeadFormToPostRequest(leadFormData, annexedParams)
    await saveLead(request).then(response => {
      if (response.success) {
        info(t('leads:notifications.addLead.success'))
        history.push(NonAuthRoutes.LeadsFile, { leadId: response.data?.id })
      } else {
        error(t('leads:notifications.addLead.error'))
      }
    })
  }

  // #endregion Handlers Ends

  // #region Functions Starts
  // #endregion Functions Ends

  // #region Form Definition Starts

  // #endregion Form Definition Ends

  // #region DataTable Config Starts
  // #endregion DataTable Config Ends

  // #region Hooks Starts
  // #endregion Hooks Ends

  return (
    <Page fullWidth={true}>
      <PageHeader title={t('leads:forms.add.title')}>
        <Button variant="text" color="primary" size="small" onClick={handleGoBack}>
          {t('leads:actions.back')}
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={handleSave}
          disabled={!formIsValid}
        >
          {t('leads:actions.save')}
        </Button>
      </PageHeader>
      <PageCenterColumn>
        <Paper elevation={6}>
          <LeadForm
            leadFormData={leadFormData}
            onFormChange={handleFormChange}
            onAnnexedParamsChange={handleAnnexedParamChange}
            commodity={commodity}
            leadType={leadType}
          />
        </Paper>
      </PageCenterColumn>
    </Page>
  )
}
